import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TemplateContext, TemplateTypeContext, PageIdContext, GetSiteDataContext } from '../../../contexts/SiteSettingsProvider';
import TemplateSkeleton from '../TemplateSkeleton/TemplateSkeleton'
import TemplateSelector from '../TemplateSelector/TemplateSelector';

function TemplateLoader() {
    const getSiteData = useContext(GetSiteDataContext);
    const templateType = useContext(TemplateTypeContext);
    const pageid = useContext(PageIdContext);
    const template = useContext(TemplateContext);

    const location = useLocation();

    useEffect(() => {

        getSiteData();
    }, [location.pathname]);

    // Use pageId straight from context. getSiteData sets pageId, templateType and
    // template together, so they're always consistent. The previous local pageId
    // state lagged a render behind templateType, so navigating to /search mounted
    // the page once with the OLD pageId — firing a duplicate searchpage/search
    // request — before correcting to the new one.
    if (!templateType || !pageid) {
        return <TemplateSkeleton />;
    }

    // Render the template based on the templateType value
    return (
        <TemplateSelector key={pageid} templateType={templateType} pageId={pageid} template={template} />
    );
}

export default TemplateLoader;